// src/firebase.js

// Importa as funções que precisamos da biblioteca que instalamos
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
 


// A sua configuração do Firebase (que você já tinha)
const firebaseConfig = {
    apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID
  };

  // Initialize Firebase
  const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const functions = getFunctions(app, 'southamerica-east1'); // <-- ADICIONADO
export const auth = getAuth(app);
export const storage = getStorage(app);
// Nota: 'southamerica-east1' é a região de São Paulo. Isso garante que o app
// converse com a função na região mais próxima, diminuindo a latência.